<script>
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: {
            urlRef: String,
            course: Object
        },
        data() {
            return {
                form: new Form({
                    course_id: this.course.id,
                    company: this.course.company.id,
                    ref: this.urlRef,
                    email: '',
                    phone: '',
                    message: '',
                    'g-recaptcha-response': null,
                })
            }
        },
        computed: {
            filledForm() {
                let data = this.form.data()
                for (let prop in data) {
                    if (! data[prop]) {
                        return false
                    }
                }

                return true
            },
            minPromotion() {
                return _.minBy(this.course.promotions, i => i.price)
            },
        },
        mounted() {
            let vm = this
            $("#contactFormModal :input")
                .on('change input copy keyup', function() {
                    let data = $(this).serializeArray()
                    for (let i in data) {
                        if (vm.form.hasOwnProperty(data[i].name)) {
                            vm.$set(vm.form, data[i].name, data[i].value)
                        }
                    }
                })

            $('.course-contact-modal').on('hidden.bs.modal', () => {
                this.form.reset()
                window.grecaptcha.reset()
                this.$set(this.form, 'course_id', this.course.id)
                this.$set(this.form, 'company', this.course.company.id)
                this.$set(this.form, 'ref', this.urlRef)
            });
        },
        methods: {
            getPromotionText(promotion) {
                if (promotion && promotion.hasOwnProperty('lessons')) {
                    let lessons = promotion.lessons > 1 ? 'lezioni' : 'lezione'
                    let people = promotion.people > 1 ? 'persone' : 'persona'
                    let lessonType = promotion.lesson_type == 'group' ? 'di gruppo' : 'individuale'

                    return `${promotion.lessons} ${lessons} di ${this.course.sport.name} per ${promotion.people} ${people} a ${this.course.municipality}`
                }
                return null
            },
            onSubmit() {
                try {
                    this.$set(this.form, 'g-recaptcha-response', window.grecaptcha.getResponse())
                    this.form
                        .submit('post', route('courses.contact', this.course.id))
                        .then(response => {
                            if (gtag) {
                                // gtag('event', 'Info', {
                                //     'event_category': 'Societa',
                                //     'event_label': 'RichiestaInfo'
                                // })

                                gtag('event', 'Form', {
                                    'event_category': 'OrangoPack',
                                    'event_label': '#messaggio-societa_OrangoPack'
                                });
                            }
                            $('#spinner-loading').removeClass('d-block').addClass('d-none');
                            $("#contactform-courses").attr("disabled", false);
                            $('.course-contact-modal').modal('hide');

                            window.toastr
                                .success(
                                    "sarai ricontattato dal team dell'associazione nel piu breve tempo possibile",
                                    "Messaggio inviato"
                                );
                        })
                        .catch(error => {
                            window.grecaptcha.reset()
                            $('#spinner-loading').removeClass('d-block').addClass('d-none');
                            window.alerts
                                .error(
                                    "controlla i campi prima di inviare il messaggio",
                                    "Messaggio non inviato"
                                )
                        })

                } catch (e) {
                    //
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseContactPromotionContainer.vue